<template>
    <div class="mobile-form-container">
        <branding-header />

        <div style="display: flex; text-align: center; flex-direction: column; margin: 1.5rem auto 1rem auto;">
            <v-icon
                :size="36"
                style="color: var(--v-success-base)"
                aria-hidden="true"
            >
                mdi-check-circle
            </v-icon>
            <h3 style="color: var(--v-success-base); font-size: 1.25rem; font-weight: 600; margin: 0.25rem 0 0 0;">Thank You!</h3>
        </div>

        <p style="margin-bottom: 2rem; line-height: 1.5;">
            Your contact information has been confirmed. Thank you for helping us keep our records up to date! You can now close this page.
        </p>
    </div>
</template>

<script>
import BrandingHeader from '@/components/demos/shared/branding-header.vue';

export default {
    name: 'CompletionDemo',

    components: {
        BrandingHeader
    },

    props: {
        submission_data: {
            type: Object,
            default: () => ({})
        }
    },
}
</script>

<style lang="scss" scoped></style>
